// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"48":"laboratory","353":"contact","417":"setting","431":"getmoney","857":"report","899":"payment","962":"home","964":"product"}[chunkId] + "." + {"48":"00cc97d5","353":"0f9f20bc","417":"0261d1ac","431":"afa0094f","857":"1efb3f4f","899":"a8f9f611","962":"1d4479a6","964":"2b8af6fc"}[chunkId] + ".js";
};